<template>
  <div id="headersaved" v-loading="loading">
    <el-scrollbar>
      <div id="savedBody">
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="resultTpye"/>
        <div class="savedList" v-for="(item,index) in searchPage" :key='index' @click="goto(item)" v-if="!resultTpye">
          <div class="like_box">
            <el-image class="like_img" :src="item.ImgUrl+'?imageView2/2/w/200'" fit="contain" lazy></el-image>
          </div>
          <div class="likeBody">
            <div class="">{{item.ShowKey}}</div>
            <p>{{item.ShowValue}}</p>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import { saveBrowseTime } from "@/api/public";
import NOTN from "@/components/notnull.vue";
export default {
  name: 'headersaved',
  components: { NOTN},
  data() {
    return {
      searchPage:'',
      resultTpye:false,
      loading: false,
      pi:1,
      ps:20
    }
  },
  props: {
    userInfo: {},
    type: String,
  },
  created() {
    this.getSearchPage()
  },
  methods: {
    getSearchPage(){
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId, PageIndex: that.pi, PageSize: that.ps }
      that.loading = true
      that.$get(that.$interface.SearchPage, data).then(res => {
        if (res.Result != 0) {
          that.searchPage=res.Data
          //res.Count=0
          if(res.Count==0){
            that.resultTpye=true
          }
        }
        that.loading = false
      })
    },
    goto(obj){
      let that=this
      saveBrowseTime(obj._id,that.userInfo.MappingUserId)
      let url={key:obj.FindKey,type:'search',id:obj._id}
      let data=JSON.parse(obj.FindValue)
      let fid=data.filter(res=>{
        return res.Key=='FirstCategoryId'
      })
      let sid=data.filter(res=>{
        return res.Key=='SecondCategoryId'
      })
      let tid=data.filter(res=>{
        return res.Key=='ThirdCategoryId'
      })
      url.f=fid.length>0?fid[0].Value:''
      url.s=sid.length>0?sid[0].Value:''
      url.t=tid.length>0?tid[0].Value:''
      that.$root.$emit("isword", false);
      window.localStorage.setItem("saveSearch",JSON.stringify(obj)) 
      that.$router.push({
        path:'/market',
        query:url
      }).catch(err=>{})
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notfind{
  height: 340px !important;
}

#headersaved{
  min-height: 200px;
}
#headersaved:hover {
  text-decoration: none;
  color: #333;
}
#savedBody{
  max-height: 360px;
  margin-top: 5px;
}
.savedList{
  display: flex;
  cursor: pointer;
  padding: 4px;
}
.savedList:hover{
  background-color: #f7f7f7;
}
.like_img{
  width: 64px;
  height: 64px;
  display: block;
}
.like_box{
  width: 64px;
  margin-right: 8px;
}
.likeBody>div{
  font-weight: 700;
  line-height: 1.5;
}
.likeBody>p{
  color: #a0a0a0;
  line-height: 1.2;
}
/deep/ .el-loading-spinner{
  position: absolute;
  top: calc(100% / 2.7);
    left: calc(100% / 2.6);
}

</style>



// WEBPACK FOOTER //
// src/components/list/headersaved.vue